<template lang="pug">
v-dialog(persistent v-model="showModal" max-width="500px")
  template(v-slot:activator="{ on, attrs }")
    v-btn(color="primary" @click="showModal = true") New Unit
  v-card
    v-card-actions
      v-card-title
        span.text-h5 New Unit
      v-spacer
      v-btn(color="red" text @click="showModal=false, resetUnit()") Cancel
    v-card-text
      form
        v-text-field(v-model="newUnit.stock" label="Stock" type="text")
        v-text-field(v-model="newUnit.vin" label="Vin" type="number")
        v-text-field(v-model="newUnit.k" label="Cost" type="number")
        v-text-field(v-model="newUnit.msrp" label="MSRP" type="number")
        v-text-field(v-model="newUnit.price" label="Price" type="number")
        v-autocomplete(v-model="newUnit.category" :items="categories" auto-select-first item-value="name" item-text="name" label="Category")
        v-autocomplete(v-model="newUnit.make" :items="makes" auto-select-first item-value="name" item-text="name" label="Make")
        v-autocomplete(v-model="newUnit.model" :items="modelsbymake" auto-select-first item-value="name" item-text="name" label="Model")
        v-text-field(v-model="newUnit.width" label="Width" type="number")
        v-text-field(v-model="newUnit.length" label="Length" type="number")
        v-autocomplete(v-model="newUnit.color" :items="colors" auto-select-first label="Color")
        v-autocomplete(v-model="newUnit.features" :items="features" auto-select-first label="Features" multiple deletable-chips chips item-text="name" item-value="name")
        v-text-field(v-if="newUnit.status === 'Posted'" v-model="newUnit.website" label="Website" type="text")
      v-card-actions
        v-spacer
        v-btn(color="primary" @click="addUnit()") Add Unit
</template>
<script>

import modal from '@/components/modal'
import { mapGetters } from 'vuex'

function initialUnit () {
  return {
    stock: '',
    year: 0,
    vin: 0,
    k: 0,
    msrp: 0,
    price: 0,
    percentage: null,
    make: '',
    model: '',
    category: '',
    width: 0,
    length: 0,
    weight: 0,
    gvwr: 0,
    color: '',
    features: '',
    status: 'Entered',
    website: '',
    id: ''
  }
}
export default {
  data () {
    return {
      showModal: false,
      newUnit: initialUnit()
    }
  },
  methods: {
    resetUnit () {
      this.showModal = false
      this.newUnit = initialUnit()
    },
    addUnit () {
      this.$emit('updateSearch', this.newUnit.stock)
      this.$store.dispatch('addUnit', this.newUnit)
      this.resetUnit()
    }
  },
  computed: {
    ...mapGetters([
      'makes',
      'models',
      'colors',
      'status',
      'categories',
      'completed',
      'features'
    ]),
    modelsbymake () {
      return this.$store.getters.getModelsByMake(this.newUnit.make)
    }
  },
  components: {
    modal
  }
}
</script>
